import gql from "graphql-tag";

export const GRAPHQL_URL =
  process.env.REACT_APP_GRAPHQL_URL ?? "http://localhost:8080/graphql";

const COUNTRIES_QUERY = gql`
  query {
    appointmentcountries {
      id
      defaultName
    }
  }
`;
const CITIES_QUERY = gql`
  query ($countryId: Long!) {
    appointmentcities(countryId: $countryId) {
      id
      defaultName
    }
  }
`;

const BOUTIQUES_QUERY = gql`
  query ($cityId: Long!, $languageId: Long!) {
    appointmentboutiques(cityId: $cityId, languageId: $languageId) {
      id
      name
    }
  }
`;
const LANGUAGE_QUERY = gql`
  query {
    appointmentlanguages {
      code
      id
      locale
      name
    }
  }
`;

const ADD_APPOINTMENT_SIGNUP = gql`
  mutation appointmentsignup(
    $salutation: String!
    $firstname: String!
    $lastname: String!
    $phone: String!
    $customerEmail: String!
    $boutiqueId: Long!
    $remark: String!
    $languageId: Long!
  ) {
    appointmentsignup(
      input: {
        salutation: $salutation
        firstname: $firstname
        lastname: $lastname
        phone: $phone
        customerEmail: $customerEmail
        boutiqueId: $boutiqueId
        remark: $remark
        languageId: $languageId
      }
    )
  }
`;

export const query = {
  COUNTRIES_QUERY,
  CITIES_QUERY,
  BOUTIQUES_QUERY,
  ADD_APPOINTMENT_SIGNUP,
  LANGUAGE_QUERY,
};
